var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdNewuser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_md_newuser",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_md_newuser-2",
    "data-name": "ic_md_newuser",
    transform: "translate(-24 -24)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11625",
    "data-name": "Ellipse 11625",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#c4eda9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135112",
    "data-name": "Path 135112",
    d: "M31.48,28.59h-.7a13.14,13.14,0,0,1-11.56,0h-.7A9.72,9.72,0,0,0,8.8,38.3V43a24,24,0,0,0,9.75,5.4h12.9A24,24,0,0,0,41.2,43V38.3A9.72,9.72,0,0,0,31.48,28.59Z",
    transform: "translate(-1 -1.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11626",
    "data-name": "Ellipse 11626",
    cx: 9.24,
    cy: 9.24,
    r: 9.24,
    transform: "translate(14.76 5.68)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135113",
    "data-name": "Path 135113",
    d: "M30.75,9a9.24,9.24,0,0,1-13,13,9.24,9.24,0,1,0,13-13Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135114",
    "data-name": "Path 135114",
    d: "M20,18a.33.33,0,0,0-.31.41,5.46,5.46,0,0,0,10.58,0A.33.33,0,0,0,30,18Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135115",
    "data-name": "Path 135115",
    d: "M25,7a9.24,9.24,0,1,1-9.24,9.24A9.24,9.24,0,0,1,25,7m0-2A11.24,11.24,0,1,0,36.24,16.23,11.24,11.24,0,0,0,25,5Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135116",
    "data-name": "Path 135116",
    d: "M19.27,38.9a.6.6,0,0,1,0-.84l.83-.83a.6.6,0,0,1,.84,0l2.58,2.58,5.54-5.54a.6.6,0,0,1,.84,0l.83.84a.59.59,0,0,1,0,.83l-6.79,6.79a.59.59,0,0,1-.83,0Z",
    transform: "translate(-1 -1.31)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135117",
    "data-name": "Path 135117",
    d: "M33.5,40.2v7.55a24.821,24.821,0,0,0,3.26-1.52Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135118",
    "data-name": "Path 135118",
    d: "M16.54,47.77V40.2l-3.26,6A24.82,24.82,0,0,0,16.54,47.77Z",
    transform: "translate(-1 -1.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135119",
    "data-name": "Path 135119",
    d: "M22.41,15.25a.87.87,0,0,1-.86-.87V13.27a.87.87,0,0,1,1.73,0v1.11A.87.87,0,0,1,22.41,15.25Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135120",
    "data-name": "Path 135120",
    d: "M27.59,15.25a.87.87,0,0,1-.87-.87V13.27a.87.87,0,0,1,1.73,0v1.11a.87.87,0,0,1-.86.87Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135121",
    "data-name": "Path 135121",
    d: "M25,3.31a22,22,0,1,1-22,22,22,22,0,0,1,22-22m0-2a24,24,0,1,0,24,24A24,24,0,0,0,25,1.31Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135122",
    "data-name": "Path 135122",
    d: "M8.8,42.06a1,1,0,0,1-1-1V38.3A10.73,10.73,0,0,1,18.52,27.58h.7a1,1,0,0,1,.43.1,12.06,12.06,0,0,0,10.69,0,1.13,1.13,0,0,1,.44-.1h.7A10.73,10.73,0,0,1,42.2,38.3v2.76a1,1,0,0,1-2,0V38.3a8.73,8.73,0,0,0-8.72-8.72H31a14,14,0,0,1-12,0h-.48A8.73,8.73,0,0,0,9.8,38.3v2.76a1,1,0,0,1-1,1Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135123",
    "data-name": "Path 135123",
    d: "M16.54,46.66a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,1,0v6A.5.5,0,0,1,16.54,46.66Z",
    transform: "translate(-1 -1.31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135124",
    "data-name": "Path 135124",
    d: "M33.5,46.66a.5.5,0,0,1-.5-.5v-6a.5.5,0,0,1,1,0v6A.5.5,0,0,1,33.5,46.66Z",
    transform: "translate(-1 -1.31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdNewuser);
export default __webpack_public_path__ + "static/media/ic_md_newuser.f18ae941c72a58390cd35168dc5f4a69.svg";
export { ForwardRef as ReactComponent };